<template lang="pug">
div
  row.mb-2(
    v-for="item, index in model"
    :key="item.codigo"
    :grau-infracao="item"
    :index="index"
    @submit="onSubmit"
    @remove="onRemoveRow"
  )
  a.btn.btn-link.mt-2(@click="formOpen = true" v-if="!formOpen && model.length")
    btn-content(label="Adicionar grau de infração" icon="fa fa-plus")
  form-grau-infracao.mt-2(v-else-if="formOpen" @submit="onSubmit" @cancel="closeForm")
  .empty(v-if="!model.length && !formOpen")
    .empty-icon
      i.fa.fa-file-text-o.fa-3x
    p.empty-title.h5 Nenhum grau de infração
    p.empty-subtitle Você não adicionou nenhum grau de infração
    .empty-action
      button.btn.btn-default(type="button" @click="formOpen = true")
        btn-content(icon="fa fa-plus" label="Adicionar grau de infração")
</template>

<script>
import { deepClone } from 'paliari-js-utils'
import FormGrauInfracao from './Form'
import Row from './Row'

export default {
  data() {
    return { formOpen: false }
  },
  components: { FormGrauInfracao, Row },
  computed: {
    model: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      },
    },
  },
  methods: {
    closeForm() {
      this.formOpen = false
    },
    onSubmit({ resource, index = null }) {
      const position = index !== null ? index : this.model.length
      this.$set(this.model, position, resource)
      this.closeForm()
    },

    onRemoveRow(index) {
      const replaced = deepClone(this.model)
      this.$delete(replaced, index)
      this.model = replaced
    },
  },
  props: {
    value: { type: Array, default: () => [] },
  },
}
</script>
